import { Controller } from "@hotwired/stimulus"

// Reveals image when loaded (CSP-safe, no inline handlers). Handles cached images too.
export default class extends Controller {
  connect() {
    if (this.element.complete) this.reveal()
  }

  reveal() {
    this.element.classList.remove("opacity-0")
    this.element.classList.add("opacity-100")
  }
}
